import { render } from "./video-advice.vue?vue&type=template&id=32ce5a6b&scoped=true"
import script from "./video-advice.vue?vue&type=script&lang=js"
export * from "./video-advice.vue?vue&type=script&lang=js"

import "./video-advice.vue?vue&type=style&index=0&id=32ce5a6b&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32ce5a6b"]])

export default __exports__